import HorizontalAvailability from "./HorizontalAvailability.component";

export default HorizontalAvailability;
